<ui-dropdown
	#dropdown
	[dropdownItemTemplate]="dropdownTemplate"
	[items]="notes()"
	[triggerOnHover]="true"
	dropdownContentClass="max-w-md"
	[customDropdownContent]="dropdownCustomContent"
	size="lg"
	[testHook]="testHooks.MatterNavNotesButton"
	intercomTarget="matter-topnav-notes"
>
	<div class="px-2.5 py-1 rounded-lg bg-white cursor-pointer">
		<div class="flex items-center gap-2">
			<i-tabler name="note" class="w-4 h-4"></i-tabler>
			<p class="p-sm">Notes</p>
			<ui-badge size="sm" [label]="notes().length"></ui-badge>
			<i-tabler
				name="chevron-down"
				class="w-4 h-4 transition-transform duration-300"
				[class.rotate-180]="dropdown.isOpen"
			></i-tabler>
		</div>
	</div>
</ui-dropdown>

<ng-template #dropdownCustomContent>
	<div class="flex items-center gap-2 justify-between mb-2 order-first">
		<h4 class="h4 mb-0">Notes</h4>
		<ui-button
			preset="MEDIUM_EMPHASIS"
			icon="plus"
			size="sm"
			label="Add note"
			(click)="addNote()"
			[testHook]="testHooks.AddNoteButton"
		></ui-button>
	</div>
</ng-template>

<ng-template #dropdownTemplate let-item>
	<div
		class="px-3 py-2 rounded-lg border relative cursor-pointer duration-300 hover:bg-gray-50"
		[ngClass]="{
			'order-first bg-amber-50 border-amber-200': item.pinned,
			'border-gray-200 bg-white': !item.pinned,
		}"
		(click)="selectNote(item.id)"
		[testHook]="
			item.pinned
				? testHooks.SelectPinnedNoteDiv
				: testHooks.SelectUnpinnedNoteDiv
		"
	>
		@if (item.pinned) {
			<ui-badge
				type="warning"
				size="sm"
				icon="pin"
				class="absolute top-0 right-0 translate-x-1/2 -translate-y-1/2"
			></ui-badge>
		}
		<h5 class="h5 truncate">{{ item?.title }}</h5>
		<p class="p-xs truncate mb-1">{{ item?.description }}</p>
		<p class="p-xs text-grey">
			{{ item?.creatorFirstName }} {{ item?.creatorLastName }} -
			{{ item?.createdAt | date: 'MMM d, yyyy' }}
		</p>
	</div>
</ng-template>
